import { configureStore } from '@reduxjs/toolkit'
import pageSlice from './features/pageSlice'
import examSlice from './features/examSlice'
import authReducer from './features/authSlice'


export const store = configureStore({
    reducer: {
        page: pageSlice,
        exam: examSlice,
        auth: authReducer,
    },
  })